/// <reference path="../../typings/index.d.ts" />

module monitoringApp.common {
    angular.module('common.services', ['ngResource']);
}